<template>
  <v-main>
    <v-container fluid>
      <v-row align="center" justify="center">
      <v-data-table
        :headers="headers"
        :items="lists"
        :loading="loading"
        :search="search"
        :sort-desc="[false, true]"
        fixed-header
        height="50vh"
        multi-sort
        dark
        dense
        class="table"
        item-key="id"
        scope="props"
      >
        <template v-slot:top>
          <v-toolbar flat dark rounded>
            <v-toolbar-title>Lists</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <export-excel :data="lists" name="lists">
              <v-btn color="primary"><v-icon color="white">mdi-file-download</v-icon></v-btn>
            </export-excel>
          </v-toolbar>
        </template>
        <template v-slot:[`item.intro`]="{ item }">
          <span @click="openIntroDialog(item.intro)"><a>Ver</a></span>
          <v-dialog v-model="introDialog.enabled" max-width="300" :retain-focus="false">
            <v-card>
              <v-container>
                {{ introDialog.intro }}
              </v-container>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.slug`]="{ item }">
          <a :href="'https://sites.mimon.com.br/' + item.slug" target="_blank">{{ item.slug }}</a>
        </template>
        <template v-slot:[`item.gifts`]="{ item }">
          <span @click="openGiftsDialog(item.gifts)"><a>Ver</a></span>
          <v-dialog v-model="giftsDialog.enabled" max-width="300" :retain-focus="false">
            <v-card>
              <v-container>
                <v-row v-for="item in giftsDialog.gifts" :key="item._id">
                  {{ item.gift.product.name }}: <span class="ml-auto gold">{{ item.gift.product.price | toCurrency }}</span>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.medias`]="{ item }">
          <span @click="openMediasDialog(item.medias)"><a>Ver</a></span>
          <v-dialog v-model="mediasDialog.enabled" max-width="300" :retain-focus="false">
            <v-row dense>
                <strong class="gold mb-5 mx-auto">Images:</strong>
                <v-col class="d-flex" v-for="(item, i) in $options.filters.mediasImages(mediasDialog.medias)" :key="item._id" :cols="i === 0 ? 12 : 6">
                  <v-card>
                    <v-img :src="'https://b2cproduct-dev.s3.us-west-2.amazonaws.com/public/' + item.media.src" class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px">
                    </v-img>
                  </v-card>
                </v-col>
            </v-row>
            <v-row class="mt-10" dense>
                <strong class="gold mb-5 mx-auto">Videos:</strong>
                <v-col class="d-flex" v-for="(item, i) in $options.filters.mediasVideos(mediasDialog.medias)" :key="item._id" :cols="i === 0 ? 12 : 6">
                  <v-card>
                    <video :src="'https://b2cproduct-dev.s3.us-west-2.amazonaws.com/public/' + item.media.src" controls width="250"></video>
                  </v-card>
                </v-col>
            </v-row>
          </v-dialog>
        </template>
        <template v-slot:[`item.messages`]="{ item }">
          <span @click="openMessagesDialog(item.messages)"><a>Ver</a></span>
          <v-dialog v-model="messagesDialog.enabled" max-width="300" :retain-focus="false">
            <v-card>
              <v-container>
                <v-row class="mb-10 flex-column" v-for="item in messagesDialog.messages" :key="item._id" dense>
                  <div class="d-flex"><span class="mb-2 gold">{{ item.message }}</span></div>
                  <div class="d-flex">Created At: <span class="ml-auto gold">{{ formatDate(item.createdAt) }}</span></div>
                  <div class="d-flex">Active: <span class="mb-2 ml-auto gold">{{ item.isActive ? 'yes' : 'no' }}</span></div>
                  <div class="d-flex my-2 mx-auto">Author</div>
                  <div class="d-flex">Name: <span class="ml-auto gold">{{ item.author.name }}</span></div>
                  <div class="d-flex">Email: <span class="mb-15 ml-auto gold">{{ item.author.email }}</span></div>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.config`]="{ item }">
          <span @click="openConfigDialog(item.config)"><a>Ver</a></span>
          <v-dialog v-model="configDialog.enabled" max-width="300" :retain-focus="false">
            <v-card>
              <v-container>
                <v-row class="flex-column" dense>
                  <div class="d-flex">Protected: <span class="ml-auto gold">{{ configDialog.config.protected.isActive ? 'yes' : 'no' }}</span></div>
                  <div class="d-flex">Domain: <span class="ml-auto gold">{{ configDialog.config.domain.isActive ? 'yes' : 'no' }}</span></div>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.template`]="{ item }">
          <span @click="openTemplateDialog(item.template)"><a>Ver</a></span>
          <v-dialog v-model="templateDialog.enabled" max-width="300" :retain-focus="false">
            <v-card>
              <v-container>
                <v-row dense>
                  <v-col class="d-flex" cols="12">
                    <v-card>
                      <v-img :src="'https://b2cproduct-dev.s3.us-west-2.amazonaws.com/public/' + templateDialog.template.cover" class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="100px">
                      </v-img>
                    </v-card>
                  </v-col>
                  <v-col class="d-flex justify-center" cols="12">
                    <v-card>
                      <v-img :src="templateDialog.template.avatar" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" width="75" height="75">
                      </v-img>
                    </v-card>
                  </v-col>
                  <div class="d-flex mt-5 mr-auto">Color: </div>
                  <div class="mt-3" :style="{backgroundColor: templateDialog.template.color, width: '25px'}"></div>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.infos`]="{ item }">
          <span @click="openInfosDialog(item.infos)"><a>Ver</a></span>
          <v-dialog v-model="infosDialog.enabled" max-width="300" :retain-focus="false">
            <v-card>
              <v-container>
                <v-row class="flex-column" dense>
                  <div class="d-flex">Visits: <span class="ml-auto gold">{{ infosDialog.infos.visits }}</span></div>
                  <div class="d-flex">Confirmed: <span class="ml-auto gold">{{ infosDialog.infos.confirmed }}</span></div>
                  <div class="d-flex">Gifts Received: <span class="ml-auto gold">{{ infosDialog.infos.giftsReceived }}</span></div>
                  <div class="d-flex">Messages Received: <span class="ml-auto gold">{{ infosDialog.infos.messagesReceived }}</span></div>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.services`]="{ item }">
          <span @click="openServicesDialog(item.services)"><a>Ver</a></span>
          <v-dialog v-model="servicesDialog.enabled" max-width="300" :retain-focus="false">
            <v-card>
              <v-container>
                <v-row dense>
                  <v-col class="d-flex flex-column mb-15" v-for="item in servicesDialog.services" :key="item.id">
                    <div class="d-flex">Limit: <span class="ml-auto gold">{{ item.limit }}</span></div>
                    <div class="d-flex">Available: <span class="ml-auto gold">{{ item.service.available ? 'yes' : 'no' }}</span></div>
                    <div class="d-flex">Active: <span class="ml-auto gold">{{ item.isActive ? 'yes' : 'no' }}</span></div>
                    <div class="d-flex">Created At: <span class="ml-auto gold">{{ formatDate(item.createdAt) }}</span></div>
                    <span class="mx-auto mt-5 mb-2">Service</span>
                    <div class="d-flex">Title: <span class="ml-auto gold">{{ item.service.title }}</span></div>
                    <v-card v-if="item.service.length">
                      <v-img :src="item.service.img" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" width="75" height="75">
                      </v-img>
                    </v-card>
                    <div class="d-flex">Description:</div>
                    <div class="d-flex"><span class="gold">{{ item.service.description }}</span></div>
                    <div class="d-flex">Title: <span class="ml-auto gold">{{ item.service.title }}</span></div>
                    <div class="d-flex">Value: <span class="ml-auto gold">{{ item.service.value | toCurrency }}</span></div>
                    <div class="d-flex">Limit: <span class="ml-auto gold">{{ item.service.limit }}</span></div>
                    <div class="d-flex">Buy Limit: <span class="ml-auto gold">{{ item.service.buyLimit }}</span></div>
                    <div class="d-flex">Key: <span class="ml-auto gold">{{ item.service.key }}</span></div>
                    <div class="d-flex">Active: <span class="ml-auto gold">{{ item.service.isActive ? 'yes' : 'no' }}</span></div>
                    <div class="d-flex">Free Limit: <span class="ml-auto gold">{{ item.service.freeLimit }}</span></div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.rsvp`]="{ item }">
          <span @click="openRsvpDialog(item.rsvp)"><a>Ver</a></span>
          <v-dialog v-model="rsvpDialog.enabled" max-width="300" :retain-focus="false">
            <v-card>
              <v-container>
                <v-row dense>
                  <v-col class="d-flex flex-column mb-15" v-for="item in rsvpDialog.rsvp" :key="item.id">
                    <div class="d-flex">Name: <span class="ml-auto gold">{{ item.name }}</span></div>
                    <div class="d-flex">Email: <span class="ml-auto gold">{{ item.email }}</span></div>
                    <div class="d-flex">Phone: <span class="ml-auto gold">{{ item.phone }}</span></div>
                    <div class="d-flex">Category: <span class="ml-auto gold">{{ item.category }}</span></div>
                    <div class="d-flex">Active: <span class="ml-auto gold">{{ item.isActive ? 'yes' : 'no' }}</span></div>
                    <div class="d-flex">Created At: <span class="ml-auto gold">{{ formatDate(item.createdAt) }}</span></div>
                    <span class="mx-auto mt-5 mb-2">Dependents:</span>
                      <v-card class="d-flex flex-column mb-2" v-for="(dependent, i) in item.dependents" :key="i">
                        <v-container>
                          <div class="d-flex">Name: <span class="ml-auto gold">{{ dependent.name }}</span></div>
                          <div class="d-flex">Email: <span class="ml-auto gold">{{ dependent.email }}</span></div>
                          <div class="d-flex">Category: <span class="ml-auto gold">{{ dependent.category }}</span></div>
                        </v-container>
                      </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          <span>{{ formatDate(item.createdAt) }}</span>
        </template>
      </v-data-table>
      </v-row>
    </v-container>
  </v-main>
</template>

<style lang="scss">
  .table {
    width: 85%;
    .search {
      margin-right: 25px;
      max-width: 300px;
    }
  }
  th {
    span { font-size: 15px; }
    color: gold !important;
  }
  .v-dialog { box-shadow: none !important;}
  .large { min-width: 125px; }
  .gold { color: gold; }
</style>

<script>
/* eslint-disable */
import { formatDate } from '@/utils/date'

const translatedTableTitles = {}
const translatedTableFields = {}
const translatedGeneralWordsAndPhrases = {}

const hiddenTableColumns = ['id', 'link']

export default {
  name: 'Lists',
  data () {
    return {
      loading: true,
      search: '',
      headers: [],
      lists: [],
      introDialog: {
        enabled: false,
        intro: ''
      },
      giftsDialog: {
        enabled: false,
        gifts: []
      },
      mediasDialog: {
        enabled: false,
        medias: []
      },
      messagesDialog: {
        enabled: false,
        messages: []
      },
      configDialog: {
        enabled: false,
        config: {
          protected: {
            isActive: false,
            password: '',
          },
          domain: {
            isActive: false
          }
        }
      },
      templateDialog: {
        enabled: false,
        template: {
          avatar: '',
          cover: '',
          color: ''
        }
      },
      infosDialog: {
        enabled: false,
        infos: {
          visits: 0,
          confirmed: 0,
          giftsReceived: 0,
          messagesReceived: 0
        }
      },
      servicesDialog: {
        enabled: false,
        services: []
      },
      rsvpDialog: {
        enabled: false,
        rsvp: []
      }
    }
  },
  mounted () {
    let headerCreated = false
    let dessert = {}

    this.$store.watch(
      state => state.lists,
      lists => {
       Object.entries(lists).map(([_, value]) => {
        dessert = {}
        Object.entries(value).map(([key, value]) => {
          if (!headerCreated) 
            this.headers.push({ text: key, value: key, class: 'large', align: hiddenTableColumns.includes(key) ? ' d-none' : ''})
        
          dessert = { ...dessert, [key]: value }
        })
        this.lists.push(dessert)
        headerCreated = true
      })
      this.loading = false
    })
     
  },
  filters: {
    mediasImages: (medias) => medias.filter(media => media.media.mimeType.includes('image')),
    mediasVideos: (medias) => medias.filter(media => media.media.mimeType.includes('video')) 
  },
  methods: {
    openIntroDialog (intro) { this.introDialog = { enabled: true, intro } },
    openGiftsDialog (gifts) { this.giftsDialog = { enabled: true, gifts } 
      },
    openMediasDialog (medias) { 
      if (medias === undefined) {
        alert('There is no media for this list')
        return
      }  
      this.mediasDialog = { enabled: true, medias } 
    },
    openMessagesDialog (messages) { 
      if (messages === undefined) {
        alert('There is no messages for this list')
        return
      }
      this.messagesDialog = { enabled: true, messages } 
    },
    openConfigDialog (config) { this.configDialog = { enabled: true, config } },
    openTemplateDialog (template) { this.templateDialog = { enabled: true, template } },
    openInfosDialog (infos) { this.infosDialog = { enabled: true, infos } },
    openServicesDialog (services) { 
      if (services === undefined) {
        alert('There is no services for this list')
        return
      }
      this.servicesDialog = { enabled: true, services } 
    },
    openRsvpDialog (rsvp) { 
      if (rsvp === undefined) {
        alert('There is no rsvp for this list')
        return
      }
      this.rsvpDialog = { enabled: true, rsvp } 
    },
    translateTableTitle (word) { return (word in translatedTableTitles) ? translatedTableTitles[word] : word },
    translateTableField (word) { return (word in translatedTableFields) ? translatedTableFields[word] : word },
    translateGeneralWordsAndPhrases (expression) { return (expression in translatedGeneralWordsAndPhrases) ? translatedGeneralWordsAndPhrases[expression] : expression },
    formatDate(date) { return formatDate(date) }
  }
}
</script>